<template>
  <v-card v-if="localRecord">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                :items="items"
                item-text="text"
                item-value="value"
                :label="selectLabel"
                v-model="localRecord[selectField]"
                :rules="[() => !!localRecord[selectField] || 'Champ obligatoire']"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="localRecord.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="localRecord.date"
                    label="* Date:"
                    prepend-icon="mdi-calendar"
                    readonly
                    :rules="[() => !!localRecord.date || 'Champ obligatoire']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-CH"
                  first-day-of-week="1"
                  v-model="localRecord.date"
                  @input="$refs.menu1.save(localRecord.date)"
                  :allowed-dates="allowedDates"
                  :events="hasWorkingDays ? allowedDates : false"
                  event-color="green"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea outlined name="input-7-1" label="Commentaire" v-model="localRecord.comment"></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="close">Annuler</v-btn>
        <v-btn :disabled="isDisabled" color="blue darken-1" text @click.native="save">Sauvegarder</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { cloneDeep } from "lodash"

export default {
  props: {
    record: {
      required: true,
    },
    formTitle: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    selectLabel: {
      type: String,
      required: true,
    },
    selectField: {
      type: String,
      required: true,
    },
    workingDays: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    this.localRecord = cloneDeep(this.record)
  },
  watch: {
    record: function (record) {
      if (record) {
        this.localRecord = cloneDeep(this.record)
      }
    },
  },
  data() {
    return {
      menu1: false,
      valid: false,
      localRecord: null,
    }
  },
  computed: {
    isDisabled() {
      return !this.localRecord.date || !this.localRecord[this.selectField]
    },
    hasWorkingDays() {
      return this.workingDays && this.workingDays.length > 0
    },
  },
  methods: {
    allowedDates(date) {
      if (!this.workingDays || this.workingDays.length === 0) return true
      return this.workingDays.includes(date)
    },
    save() {
      this.$emit("save", this.localRecord)
      this.localRecord = null
    },
    close() {
      this.$emit("cancel")
    },
  },
}
</script>
